export default __webpack_public_path__ + "static/media/plus.6abc60d2.svg";